// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mp-1";
export var messageSideRight = "_mp-2";
export var subscribeToBackInStockBubbleContainer = "_mp-0";